/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface PublisherIdLanguagesGet$Json$Params {
  id: string;
}

export function publisherIdLanguagesGet$Json(http: HttpClient, rootUrl: string, params: PublisherIdLanguagesGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, publisherIdLanguagesGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

publisherIdLanguagesGet$Json.PATH = '/Publisher/{id}/Languages';
